const $document = $(document);
const $body = $('body');


const $mainHeader = $('[data-sticky="main-header"]');
const $topBar = $('[data-sticky="top-bar"]');

let listenersAdded = false;

function isTopBarVisible() {
  const topBarRect = $topBar[0]?.getBoundingClientRect();
  return topBarRect?.bottom > 0 && topBarRect?.top < window.innerHeight;
}

function toggleStickyHeader() {
  if (!isTopBarVisible()) {
    $mainHeader.addClass('main-header-sticky');
    $body.addClass('main-header-sticky');
  } else {
    $mainHeader.removeClass('main-header-sticky');
    $body.removeClass('main-header-sticky');
  }
}

function addListeners() {
  if (!listenersAdded && $mainHeader?.length && $topBar?.length) {
    $document.on('resize', function () {
      toggleStickyHeader();
    });

    $document.on('scroll', function () {
      toggleStickyHeader();
    });

    listenersAdded = true;
  }
}

$document.on('ready', function () {
  toggleStickyHeader();
  addListeners();
});
